import RecruiterSearch from "@/components/RecruiterSearch";

export default function RecruiterPortal() {
  return <RecruiterSearch />;
}
